import { IconProps } from "./Icon.model";

export function Browser({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8314 6.89495C14.8302 6.70918 14.8297 6.61629 14.7712 6.55815C14.7127 6.5 14.6194 6.5 14.4328 6.5H1.56738C1.3808 6.5 1.28751 6.5 1.22901 6.55815C1.1705 6.61629 1.16993 6.70918 1.1688 6.89495C1.16674 7.23052 1.16675 7.58581 1.16675 7.96188V8.03812C1.16674 9.49858 1.16673 10.6457 1.28714 11.5413C1.41054 12.4591 1.66856 13.1873 2.24069 13.7594C2.81282 14.3315 3.54099 14.5895 4.45876 14.7129C5.35437 14.8333 6.50148 14.8333 7.96195 14.8333H8.03819C9.49866 14.8333 10.6458 14.8333 11.5414 14.7129C12.4592 14.5895 13.1873 14.3315 13.7595 13.7594C14.3316 13.1873 14.5896 12.4591 14.713 11.5413C14.8334 10.6457 14.8334 9.4986 14.8334 8.03813V7.96189C14.8334 7.58582 14.8334 7.23052 14.8314 6.89495Z"
        fill={fillColor}
      />
      <path
        d="M8.03711 1.16699C9.49733 1.16698 10.6445 1.16676 11.54 1.28711C12.4578 1.41049 13.1867 1.66816 13.7588 2.24023C14.3309 2.81237 14.5885 3.54121 14.7119 4.45898C14.7382 4.65434 14.7593 4.8621 14.7754 5.08203C14.7895 5.27555 14.7966 5.37275 14.7373 5.43652C14.678 5.50032 14.5787 5.5 14.3809 5.5H1.61816C1.42048 5.5 1.32108 5.50005 1.26172 5.43652C1.20243 5.37275 1.20951 5.27559 1.22363 5.08203C1.23968 4.86212 1.25988 4.65433 1.28613 4.45898C1.40952 3.54121 1.6681 2.81237 2.24023 2.24023C2.81231 1.66838 3.54045 1.41047 4.45801 1.28711C5.35357 1.16672 6.50061 1.16698 7.96094 1.16699H8.03711ZM4.66699 2.66699C4.29891 2.66699 4.00018 2.96497 4 3.33301C4 3.7012 4.2988 4 4.66699 4H4.67285C5.04097 3.99991 5.33887 3.70114 5.33887 3.33301C5.33869 2.96502 5.04086 2.66708 4.67285 2.66699H4.66699ZM7.33301 2.66699C6.96509 2.66718 6.66717 2.96509 6.66699 3.33301C6.66699 3.70108 6.96498 3.99981 7.33301 4H7.33887C7.70706 4 8.00586 3.7012 8.00586 3.33301C8.00568 2.96497 7.70695 2.66699 7.33887 2.66699H7.33301Z"
        fill={fillColor}
      />
    </svg>
  );
}

